export const TechnologiesMainData = [
    { id: 1, title: "Blockchain" },
    { id: 2, title: "Frontend" },
    { id: 3, title: "Backend" },
    { id: 4, title: "AI" },
    { id: 5, title: "Mobile" },
    { id: 6, title: "UIUX" },
];

export const BlockchainData = [
    {
        id: 1,
        image: "/assets/common/Blockchain/Ethereum.webp",
        title: "Ethereum",
        discription:
            "Decentralized platform for smart contracts and DApps via Ether (ETH).",
    },
    {
        id: 2,
        image: "/assets/common/Blockchain/Polygon.webp",
        title: "Polygon",
        discription:
            "Layer 2 scaling for Ethereum with faster, cheaper transactions.",
    },
    {
        id: 3,
        image: "/assets/common/Blockchain/Cardano.webp",
        title: "Cardano",
        discription:
            "Proof-of-stake blockchain focusing on security, sustainability, and scalability.",
    },
    {
        id: 4,
        image: "/assets/common/Blockchain/Solana.webp",
        title: "Solana",
        discription:
            "High-performance blockchain with low fees and fast processing for DApps.",
    },
];

export const BlockchainDataTech = [
    {
        id: 1,
        image: "/assets/common/Blockchain/Avalanche.webp",
        title: "Avalanche",
    },
    {
        id: 2,
        image: "/assets/common/Blockchain/Pimlico.webp",
        title: "Pimlico",
    },
    {
        id: 3,
        image: "/assets/common/Blockchain/ZeroDev.webp",
        title: "ZeroDev",
    },
    {
        id: 4,
        image: "/assets/common/Blockchain/Optimism.webp",
        title: "Optimism",
    },
    {
        id: 5,
        image: "/assets/common/Blockchain/Alchemy.webp",
        title: "Alchemy",
    },
    {
        id: 6,
        image: "/assets/common/Blockchain/SafewalletSDKs5.webp",
        title: "Safe Wallet SDKs5",
    },
    {
        id: 7,
        image: "/assets/common/Blockchain/XRPLedger.webp",
        title: "XRP Ledger",
    },
    {
        id: 8,
        image: "/assets/common/Blockchain/Chainlink.webp",
        title: "Chainlink",
    },
    {
        id: 9,
        image: "/assets/common/Blockchain/ThirdwebSDK.webp",
        title: "Thirdweb SDK",
    },
    { id: 10, image: "/assets/common/Blockchain/Wasm.webp", title: "Wasm" },
    { id: 11, image: "/assets/common/Blockchain/Infura.webp", title: "Infura" },
    {
        id: 12,
        image: "/assets/common/Blockchain/Truffle.webp",
        title: "Truffle",
    },
    {
        id: 13,
        image: "/assets/common/Blockchain/Hyperledger-Fabric.webp",
        title: "Hyperledger Fabric",
    },
    {
        id: 14,
        image: "/assets/common/Blockchain/Web3AuthSDKs.webp",
        title: "Web3 Auth SDKs",
    },
    {
        id: 15,
        image: "/assets/common/Blockchain/Arbitrum.webp",
        title: "Arbitrum",
    },
    {
        id: 16,
        image: "/assets/common/Blockchain/Solidity.webp",
        title: "Solidity",
    },
    {
        id: 17,
        image: "/assets/common/Blockchain/Remix.webp",
        title: "Remix",
    },
    {
        id: 18,
        image: "/assets/common/Blockchain/Ganache.webp",
        title: "Ganache",
    },
    {
        id: 19,
        image: "/assets/common/Blockchain/Web3JS.webp",
        title: "Web3.JS",
    },
    {
        id: 20,
        image: "/assets/common/Blockchain/EVM.webp",
        title: "EVM",
    },
    {
        id: 21,
        image: "/assets/common/Blockchain/Base.webp",
        title: "Base",
    },
];

export const FrontendData = [
    {
        id: 1,
        image: "/assets/common/Frontend/NEXTJS.webp",
        title: "Next Js",
        discription:
            "React framework for server-side rendering and static websites.",
    },
    {
        id: 2,
        image: "/assets/common/Frontend/Reactjs.webp",
        title: "React Js",
        discription: "JavaScript library for building user interfaces.",
    },
    {
        id: 3,
        image: "/assets/common/Frontend/AngularJs.webp",
        title: "Angular Js",
        discription:
            "Google-maintained framework for dynamic web applications.",
    },
    {
        id: 4,
        image: "/assets/common/Frontend/vuejs.webp",
        title: "Vue Js",
        discription: "Progressive framework for building user interfaces.",
    },
];

export const FrontendDataTech = [
    {
        id: 1,
        image: "/assets/common/Frontend/D3JS.webp",
        title: "D3.JS",
        hour: [
            "from $10/ hr",
            "from $15/ hr",
            "from $20/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 2,
        image: "/assets/common/Frontend/Twilio.webp",
        title: "Twilio",
        hour: [
            "from $20/ hr",
            "from $25/ hr",
            "from $30/ hr",
            "from $110/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 3,
        image: "/assets/common/Frontend/GoogleAPIs.webp",
        title: "Google APIs",
        hour: [
            "from $30/ hr",
            "from $35/ hr",
            "from $40/ hr",
            "from $120/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 4,
        image: "/assets/common/Frontend/HTML5.webp",
        title: "HTML5",
        hour: [
            "from $40/ hr",
            "from $45/ hr",
            "from $50/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 5,
        image: "/assets/common/Frontend/CSS.webp",
        title: "CSS",
        hour: [
            "from $50/ hr",
            "from $55/ hr",
            "from $60/ hr",
            "from $160/ mo",
            "from $180/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 6,
        image: "/assets/common/Frontend/FabricJS.webp",
        title: "Fabric.JS",
        hour: [
            "from $60/ hr",
            "from $65/ hr",
            "from $70/ hr",
            "from $1800/ mo",
            "from $158/ mo",
            "from $290/ mo",
        ],
    },
    {
        id: 7,
        image: "/assets/common/Frontend/Typescript.webp",
        title: "Typescript",
        hour: [
            "from $70/ hr",
            "from $75/ hr",
            "from $80/ hr",
            "from $960/ mo",
            "from $480/ mo",
            "from $250/ mo",
        ],
    },
    {
        id: 8,
        image: "/assets/common/Frontend/Chash.webp",
        title: "C#",
        hour: [
            "from $80/ hr",
            "from $85/ hr",
            "from $90/ hr",
            "from $160/ mo",
            "from $150/ mo",
            "from $100/ mo",
        ],
    },
    {
        id: 9,
        image: "/assets/common/Frontend/Meta.webp",
        title: "Meta",
        hour: [
            "from $90/ hr",
            "from $95/ hr",
            "from $100/ hr",
            "from $120/ mo",
            "from $150/ mo",
            "from $220/ mo",
        ],
    },
    {
        id: 10,
        image: "/assets/common/Frontend/SublimeText.webp",
        title: "Sublime Text",
        hour: [
            "from $100/ hr",
            "from $105/ hr",
            "from $110/ hr",
            "from $100/ mo",
            "from $140/ mo",
            "from $260/ mo",
        ],
    },
    {
        id: 11,
        image: "/assets/common/Frontend/Vite.webp",
        title: "Vite",
        hour: [
            "from $110/ hr",
            "from $115/ hr",
            "from $120/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 12,
        image: "/assets/common/Frontend/GA4.webp",
        title: "GA4",
        hour: [
            "from $120/ hr",
            "from $125/ hr",
            "from $130/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 13,
        image: "/assets/common/Frontend/Airflow.webp",
        title: "Airflow",
        hour: [
            "from $130/ hr",
            "from $135/ hr",
            "from $140/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 14,
        image: "/assets/common/Frontend/Pytest.webp",
        title: "Pytest",
        hour: [
            "from $140/ hr",
            "from $145/ hr",
            "from $150/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 15,
        image: "/assets/common/Frontend/MySQL.webp",
        title: "MySQL",
        hour: [
            "from $150/ hr",
            "from $155/ hr",
            "from $160/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 16,
        image: "/assets/common/Frontend/Ant_Design.webp",
        title: "Ant Design",
        hour: [
            "from $160/ hr",
            "from $165/ hr",
            "from $170/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 17,
        image: "/assets/common/Frontend/Mapbox.webp",
        title: "Mapbox",
        hour: [
            "from $170/ hr",
            "from $175/ hr",
            "from $180/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 18,
        image: "/assets/common/Frontend/GoogleDistanceMatrix.webp",
        title: "Google Distance Matrix",
        hour: [
            "from $180/ hr",
            "from $185/ hr",
            "from $190/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 19,
        image: "/assets/common/Frontend/Surface.webp",
        title: "Surface",
        hour: [
            "from $190/ hr",
            "from $195/ hr",
            "from $200/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 20,
        image: "/assets/common/Frontend/Bootstrap.webp",
        title: "Bootstrap",
        hour: [
            "from $200/ hr",
            "from $205/ hr",
            "from $210/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 21,
        image: "/assets/common/Frontend/Prismic.webp",
        title: "Prismic",
        hour: [
            "from $210/ hr",
            "from $215/ hr",
            "from $220/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 22,
        image: "/assets/common/Frontend/Tailwindcss.webp",
        title: "Tailwind CSS",
        hour: [
            "from $220/ hr",
            "from $225/ hr",
            "from $230/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 23,
        image: "/assets/common/Frontend/Rust.webp",
        title: "Rust",
        hour: [
            "from $230/ hr",
            "from $235/ hr",
            "from $240/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 24,
        image: "/assets/common/Frontend/ChartJS.webp",
        title: "Chart.JS",
        hour: [
            "from $240/ hr",
            "from $245/ hr",
            "from $250/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 25,
        image: "/assets/common/Frontend/SaS.webp",
        title: "SaS",
        hour: [
            "from $250/ hr",
            "from $255/ hr",
            "from $260/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 26,
        image: "/assets/common/Frontend/Vector.webp",
        title: "Vector",
        hour: [
            "from $260/ hr",
            "from $265/ hr",
            "from $270/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 27,
        image: "/assets/common/Frontend/Twiliosendgrid.webp",
        title: "Twiliosend grid",
        hour: [
            "from $270/ hr",
            "from $275/ hr",
            "from $280/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 28,
        image: "/assets/common/Frontend/Osm.webp",
        title: "Osm",
        hour: [
            "from $280/ hr",
            "from $285/ hr",
            "from $290/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 29,
        image: "/assets/common/Frontend/GatsbyJS.webp",
        title: "GatsbyJS",
        hour: [
            "from $290/ hr",
            "from $295/ hr",
            "from $300/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 30,
        image: "/assets/common/Frontend/ThreeJS.webp",
        title: "ThreeJS",
        hour: [
            "from $300/ hr",
            "from $305/ hr",
            "from $310/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 31,
        image: "/assets/common/Frontend/CloudflareStream.webp",
        title: "Cloudflare Stream",
        hour: [
            "from $310/ hr",
            "from $315/ hr",
            "from $320/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 32,
        image: "/assets/common/Frontend/Jest.webp",
        title: "Jest",
        hour: [
            "from $320/ hr",
            "from $325/ hr",
            "from $330/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 33,
        image: "/assets/common/Frontend/Fortran.webp",
        title: "Fortran",
        hour: [
            "from $330/ hr",
            "from $335/ hr",
            "from $340/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 34,
        image: "/assets/common/Frontend/Metabase.webp",
        title: "Metabase",
        hour: [
            "from $340/ hr",
            "from $345/ hr",
            "from $350/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 35,
        image: "/assets/common/Frontend/PaperJS.webp",
        title: "PaperJS",
        hour: [
            "from $350/ hr",
            "from $355/ hr",
            "from $360/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
    {
        id: 36,
        image: "/assets/common/Frontend/Cypress.webp",
        title: "Cypress",
        hour: [
            "from $360/ hr",
            "from $365/ hr",
            "from $370/ hr",
            "from $100/ mo",
            "from $150/ mo",
            "from $200/ mo",
        ],
    },
];

export const BackendData = [
    {
        id: 1,
        image: "/assets/common/Backend/Python.webp",
        title: "Python",
        discription: "Versatile language for web and app development.",
    },
    {
        id: 2,
        image: "/assets/common/Backend/NodeJs.webp",
        title: "Node Js",
        discription: "JavaScript runtime for scalable network applications.",
    },
    {
        id: 3,
        image: "/assets/common/Backend/Go.webp",
        title: "Go",
        discription:
            "Efficient, statically typed language for concurrent applications.",
    },
    {
        id: 4,
        image: "/assets/common/Backend/Scala.webp",
        title: "Scala",
        discription:
            "Combines object-oriented and functional programming paradigms.",
    },
];
export const BackendDataTech = [
    { id: 1, image: "/assets/common/Backend/NGINX.webp", title: "Nginx" },
    {
        id: 2,
        image: "/assets/common/Backend/JavaScript.webp",
        title: "Java Script",
    },
    {
        id: 3,
        image: "/assets/common/Backend/SQL.webp",
        title: "SQL",
    },
    {
        id: 4,
        image: "/assets/common/Backend/c.webp",
        title: "c",
    },
    { id: 5, image: "/assets/common/Backend/CPlusPlus.webp", title: "C++" },
    { id: 6, image: "/assets/common/Backend/Java.webp", title: "Java" },
    {
        id: 7,
        image: "/assets/common/Backend/Php.webp",
        title: "Php",
    },
    { id: 8, image: "/assets/common/Backend/Python.webp", title: "Python" },
    {
        id: 9,
        image: "/assets/common/Backend/Django.webp",
        title: "Django",
    },
    { id: 10, image: "/assets/common/Backend/Neo4j.webp", title: "Neo4j" },
    {
        id: 11,
        image: "/assets/common/Backend/Loki.webp",
        title: "Grafana Loki",
    },
    {
        id: 12,
        image: "/assets/common/Backend/Twilio.webp",
        title: "Twilio",
    },
    {
        id: 13,
        image: "/assets/common/Backend/SpringBoot.webp",
        title: "Spring Boot",
    },
    {
        id: 14,
        image: "/assets/common/Backend/CodeIgniter.webp",
        title: "CodeIgniter",
    },
    { id: 15, image: "/assets/common/Backend/Gitlab.webp", title: "Gitlab" },
    { id: 16, image: "/assets/common/Backend/MongoDB.webp", title: "MongoDB" },
    {
        id: 17,
        image: "/assets/common/Backend/Prometheus.webp",
        title: "Prometheus",
    },
    { id: 18, image: "/assets/common/Backend/Elk_icon.webp", title: "Elk" },
    { id: 19, image: "/assets/common/Backend/Elastic.webp", title: "Elastic" },
    { id: 20, image: "/assets/common/Backend/Stripe.webp", title: "Stripe" },
    { id: 21, image: "/assets/common/Backend/Datadog.webp", title: "Datadog" },
    { id: 22, image: "/assets/common/Backend/Github.webp", title: "Github" },
    {
        id: 23,
        image: "/assets/common/Backend/Qt.webp",
        title: "Qt",
    },
    { id: 24, image: "/assets/common/Backend/Ruby.webp", title: "Ruby" },
    {
        id: 25,
        image: "/assets/common/Backend/Twiliosendgrid.webp",
        title: "Twiliosend grid",
    },
    {
        id: 26,
        image: "/assets/common/Backend/Postgres.webp",
        title: "Postgres",
    },
    {
        id: 27,
        image: "/assets/common/Backend/Clickhouse.webp",
        title: "Click house",
    },
    {
        id: 28,
        image: "/assets/common/Backend/HereWhite.webp",
        title: "Here White",
    },
    { id: 29, image: "/assets/common/Backend/Docker.webp", title: "Docker" },
    { id: 30, image: "/assets/common/Backend/CakePHP.webp", title: "Cake PHP" },
    {
        id: 31,
        image: "/assets/common/Backend/Laravel.webp",
        title: "Laravel",
    },
    {
        id: 32,
        image: "/assets/common/Backend/Osrm.webp",
        title: "Osrm",
    },
    { id: 33, image: "/assets/common/Backend/NestJS.webp", title: "NestJS" },
    { id: 34, image: "/assets/common/Backend/Mapbox.webp", title: "Mapbox" },
    {
        id: 35,
        image: "/assets/common/Backend/MeteorJS.webp",
        title: "MeteorJS",
    },
    {
        id: 36,
        image: "/assets/common/Backend/ExpressJS.webp",
        title: "ExpressJS",
    },
    { id: 37, image: "/assets/common/Backend/Redis.webp", title: "Redis" },
    { id: 38, image: "/assets/common/Backend/Flask.webp", title: "Flask" },
];

export const dedicatedResources1 = [
    {
        id: 1,
        image: "/assets/Header/About/Dedicated resources/Hire Blockchain Developers.webp",
        href: "/hire/hire-blockchain-developers",
        title: "Hire Blockchain Developers",
    },
    {
        id: 2,
        image: "/assets/Header/About/Dedicated resources/Hire ReactJS Developers.webp",
        href: "/hire/hire-react-js-developers",
        title: "Hire ReactJS Developers",
    },
    {
        id: 3,
        image: "/assets/Header/About/Dedicated resources/Hire React Native Developers.webp",
        href: "/hire/hire-react-native-developers",
        title: "Hire React Native Developers",
    },
    {
        id: 4,
        image: "/assets/Header/About/Dedicated resources/Hire Next JS Developers.webp",
        href: "/hire/hire-next-js-developers",
        title: "Hire Next JS Developers",
    },
    {
        id: 5,
        image: "/assets/Header/About/Dedicated resources/Hire Tailwind CSS Developers.webp",
        href: "/hire/hire-tailwind-css-developers",
        title: "Hire Tailwind CSS Developers",
    },
    {
        id: 6,
        image: "/assets/Header/About/Dedicated resources/Hire Nuxt JS Developers.webp",
        href: "/hire/hire-nuxt-js-developers",
        title: "Hire Nuxt JS Developers",
    },
    {
        id: 7,
        image: "/assets/Header/About/Dedicated resources/Hire Full Stack Blockchain Developers.webp",
        href: "/hire/hire-bern-full-stack-developers",
        title: "Hire Full Stack Blockchain Developers",
    },
    {
        id: 8,
        image: "/assets/Header/About/Dedicated resources/Hire C language Developers.webp",
        href: "/",
        title: "Hire C language Developers",
    },
    {
        id: 9,
        image: "/assets/Header/About/Dedicated resources/Hire PHP Developers.webp",
        href: "/",
        title: "Hire PHP Developers",
    },
    {
        id: 10,
        image: "/assets/Header/About/Dedicated resources/Hire Animators.webp",
        href: "/",
        title: "Hire Animators",
    },
];

export const dedicatedResources2 = [
    {
        id: 1,
        image: "/assets/Header/About/Dedicated resources/Hire Angular JS Developers.webp",
        href: "/hire/hire-angular-js-developers",
        title: "Hire Angular JS Developers",
    },
    {
        id: 2,
        image: "/assets/Header/About/Dedicated resources/Hire Node JS Developers.webp",
        href: "/hire/hire-node-js-developers",
        title: "Hire Node JS Developers",
    },
    {
        id: 3,
        image: "/assets/Header/About/Dedicated resources/Hire Flutter Developers.webp",
        href: "/hire/hire-flutter-developers",
        title: "Hire Flutter Developers",
    },
    {
        id: 4,
        image: "/assets/Header/About/Dedicated resources/Hire Rust Developers.webp",
        href: "/hire/hire-rust-developers",
        title: "Hire Rust Developers",
    },
    {
        id: 5,
        image: "/assets/Header/About/Dedicated resources/Hire Golang Developers.webp",
        href: "/hire/hire-golang-developers",
        title: "Hire Golang Developers",
    },
    {
        id: 6,
        image: "/assets/Header/About/Dedicated resources/Hire Solidity Developers.webp",
        href: "/hire/hire-solidity-developers",
        title: "Hire Solidity Developers",
    },
    {
        id: 7,
        image: "/assets/Header/About/Dedicated resources/Hire Python Dev Developers.webp",
        href: "/",
        title: "Hire Python Dev Developers",
    },
    {
        id: 8,
        image: "/assets/Header/About/Dedicated resources/Hire C++ Developers.webp",
        href: "/",
        title: "Hire C++ Developers",
    },
    {
        id: 9,
        image: "/assets/Header/About/Dedicated resources/Hire Java Developer Developers.webp",
        href: "/",
        title: "Hire Java Developer Developers",
    },
    {
        id: 10,
        image: "/assets/Header/About/Dedicated resources/Hire Liveops Developer.webp",
        href: "/",
        title: "Hire Liveops Developer",
    },
];

export const dedicatedResources3 = [
    {
        id: 1,
        image: "/assets/Header/About/Dedicated resources/Hire Abstraction Developers.webp",
        href: "/hire/hire-abstraction-developer",
        title: "Hire Abstraction Developers",
    },
    {
        id: 2,
        image: "/assets/Header/About/Dedicated resources/Hire DevOps Developers.webp",
        href: "/hire/hire-devops-developers",
        title: "Hire DevOps Developers",
    },
    {
        id: 3,
        image: "/assets/Header/About/Dedicated resources/Hire Etheream Developers.webp",
        href: "/hire/hire-ethereum-developers",
        title: "Hire Etheream Developers",
    },
    {
        id: 4,
        image: "/assets/Header/About/Dedicated resources/Hire Solana Developers.webp",
        href: "/hire/hire-solana-developers",
        title: "Hire Solana Developers",
    },
    {
        id: 5,
        image: "/assets/Header/About/Dedicated resources/Hire Javascript Developers.webp",
        href: "/hire/hire-javascript-developers",
        title: "Hire Javascript Developers",
    },
    {
        id: 6,
        image: "/assets/Header/About/Dedicated resources/Hire MERN Stack Developers.webp",
        href: "/hire/hire-mern-stack-developers",
        title: "Hire MERN Stack Developers",
    },
    {
        id: 7,
        image: "/assets/Header/About/Dedicated resources/Hire Nest JS Developers.webp",
        href: "/",
        title: "Hire Nest JS Developers",
    },
    {
        id: 8,
        image: "/assets/Header/About/Dedicated resources/Hire Laravel Developers.webp",
        href: "/",
        title: "Hire Laravel Developers",
    },
    {
        id: 9,
        image: "/assets/Header/About/Dedicated resources/Hire 3D Modelling Artist.webp",
        href: "/",
        title: "Hire 3D Modelling Artist",
    },
    {
        id: 10,
        image: "/assets/Header/About/Dedicated resources/Hire UI UX Designers.webp",
        href: "/",
        title: "Hire UI UX Designers",
    },
];

export const cityWeWorkIn1 = [
    {
        id: 1,
        image: "/assets/Header/About/City work/New York.webp",
        href: "/",
        title: "New York",
    },
    {
        id: 2,
        image: "/assets/Header/About/City work/Paris.webp",
        href: "/",
        title: "Paris",
    },
    {
        id: 3,
        image: "/assets/Header/About/City work/Beijing.webp",
        href: "/",
        title: "Beijing",
    },
    {
        id: 4,
        image: "/assets/Header/About/City work/Mexico City.webp",
        href: "/",
        title: "Mexico City",
    },
    {
        id: 5,
        image: "/assets/Header/About/City work/São Paulo.webp",
        href: "/",
        title: "São Paulo",
    },
    {
        id: 6,
        image: "/assets/Header/About/City work/Hong Kong.webp",
        href: "/",
        title: "Hong Kong",
    },
    {
        id: 7,
        image: "/assets/Header/About/City work/Vienna.webp",
        href: "/",
        title: "Vienna",
    },
    {
        id: 8,
        image: "/assets/Header/About/City work/Dubai.webp",
        href: "/",
        title: "Dubai",
    },
    {
        id: 9,
        image: "/assets/Header/About/City work/Prague.webp",
        href: "/",
        title: "Prague",
    },
];

export const cityWeWorkIn2 = [
    {
        id: 1,
        image: "/assets/Header/About/City work/Toronto.webp",
        href: "/",
        title: "Toronto",
    },
    {
        id: 2,
        image: "/assets/Header/About/City work/Osaka.webp",
        href: "/",
        title: "Osaka",
    },
    {
        id: 3,
        image: "/assets/Header/About/City work/London.webp",
        href: "/",
        title: "London",
    },
    {
        id: 4,
        image: "/assets/Header/About/City work/Guangzhou.webp",
        href: "/",
        title: "Guangzhou",
    },
    {
        id: 5,
        image: "/assets/Header/About/City work/Lisbon.webp",
        href: "/",
        title: "Lisbon",
    },
    {
        id: 6,
        image: "/assets/Header/About/City work/Hangzhou.webp",
        href: "/",
        title: "Hangzhou",
    },
    {
        id: 7,
        image: "/assets/Header/About/City work/Tokyo.webp",
        href: "/",
        title: "Tokyo",
    },
    {
        id: 8,
        image: "/assets/Header/About/City work/Amsterdam.webp",
        href: "/",
        title: "Amsterdam",
    },
    {
        id: 9,
        image: "/assets/Header/About/City work/Sydney.webp",
        href: "/",
        title: "Sydney",
    },
];

export const cityWeWorkIn3 = [
    {
        id: 1,
        image: "/assets/Header/About/City work/Dhaka.webp",
        href: "/",
        title: "Dhaka",
    },
    {
        id: 2,
        image: "/assets/Header/About/City work/Barcelona.webp",
        href: "/",
        title: "Barcelona",
    },
    {
        id: 3,
        image: "/assets/Header/About/City work/Istanbul.webp",
        href: "/",
        title: "Istanbul",
    },
    {
        id: 4,
        image: "/assets/Header/About/City work/Madrid.webp",
        href: "/",
        title: "Madrid",
    },
    {
        id: 5,
        image: "/assets/Header/About/City work/Cape Town.webp",
        href: "/",
        title: "Cape Town",
    },
    {
        id: 6,
        image: "/assets/Header/About/City work/Seoul.webp",
        href: "/",
        title: "Seoul",
    },
    {
        id: 7,
        image: "/assets/Header/About/City work/Chicago.webp",
        href: "/",
        title: "Chicago",
    },
    {
        id: 8,
        image: "/assets/Header/About/City work/Los Angeles.webp",
        href: "/",
        title: "Los Angeles",
    },
    {
        id: 9,
        image: "/assets/Header/About/City work/Rio de Janeiro.webp",
        href: "/",
        title: "Rio de Janeiro",
    },
];

export const QAData = [
    {
        id: 1,
        image: "/assets/common/QA/Selenium.webp",
        title: "Selenium",
        discription: "Automates web browsers for testing purposes.",
    },
    {
        id: 2,
        image: "/assets/common/QA/Appium.webp",
        title: "Appium",
        discription: "Automates mobile applications across various platforms.",
    },
    {
        id: 3,
        image: "/assets/common/QA/Katalon.webp",
        title: "Katalon",
        discription: "Integrated test automation solution for web, mobile.",
    },
    {
        id: 4,
        image: "/assets/common/QA/TestComplete.webp",
        title: "Test Complete",
        discription: "Automates UI testing for desktop, mobile applications.",
    },
];

export const QADataTech = [
    {
        id: 1,
        image: "/assets/common/QA/BrowserStack.webp",
        title: "Browser Stack",
    },
    { id: 2, image: "/assets/common/QA/Pytest.webp", title: "Pytest" },
    {
        id: 3,
        image: "/assets/common/QA/Espresso.webp",
        title: "Espresso",
    },
    { id: 4, image: "/assets/common/QA/Perfecto.webp", title: "Perfecto" },
    {
        id: 5,
        image: "/assets/common/QA/Testpad.webp",
        title: "Testpad",
    },
    {
        id: 6,
        image: "/assets/common/QA/AvoAssure.webp",
        title: "Avo Assure",
    },
    {
        id: 7,
        image: "/assets/common/QA/Cucumber.webp",
        title: "Cucumber",
    },
    { id: 8, image: "/assets/common/QA/AppliTools.webp", title: "Appli Tools" },
    {
        id: 9,
        image: "/assets/common/QA/Postman.webp",
        title: "Postman",
    },
    { id: 10, image: "/assets/common/QA/Junit5.webp", title: "Junit5" },
    {
        id: 11,
        image: "/assets/common/QA/LambdaTest.webp",
        title: "Lambda Test",
    },
    {
        id: 12,
        image: "/assets/common/QA/ReadyAPI.webp",
        title: "Ready API",
    },
    {
        id: 13,
        image: "/assets/common/QA/RobotFramework.webp",
        title: "Robot Framework",
    },
    {
        id: 14,
        image: "/assets/common/QA/SauceLabs.webp",
        title: "Sauce Labs",
    },
    {
        id: 15,
        image: "/assets/common/QA/ZephyrEnterprise.webp",
        title: "Zephyr Enterprise",
    },
    { id: 16, image: "/assets/common/QA/TestRail.webp", title: "Test Rail" },
    {
        id: 17,
        image: "/assets/common/QA/Testmo.webp",
        title: "Testmo",
    },
    {
        id: 18,
        image: "/assets/common/QA/Xray.webp",
        title: "Xray",
    },
    {
        id: 19,
        image: "/assets/common/QA/EggplantFunctional.webp",
        title: "Eggplant Functional",
    },
    {
        id: 20,
        image: "/assets/common/QA/Jquery.webp",
        title: "Jquery",
    },
    { id: 21, image: "/assets/common/QA/Jasmine-1.webp", title: "Jasmine" },
    {
        id: 22,
        image: "/assets/common/QA/QualityLogic.webp",
        title: "Quality Logic",
    },
    {
        id: 23,
        image: "/assets/common/QA/Puppeteer.webp",
        title: "Puppeteer",
    },
    {
        id: 24,
        image: "/assets/common/QA/RanorexStudio.webp",
        title: "Ranorex Studio",
    },
    {
        id: 25,
        image: "/assets/common/QA/Practitest.webp",
        title: "Practitest",
    },
    { id: 26, image: "/assets/common/QA/Jasmine.webp", title: "Jasmine" },
    { id: 27, image: "/assets/common/QA/Selenide.webp", title: "Selenide" },
    { id: 28, image: "/assets/common/QA/JMeter.webp", title: "JMeter" },
];

export const DevopsData = [
    {
        id: 1,
        image: "/assets/common/Devops/Kubernetes.webp",
        title: "Kubernetes",
        discription:
            "Orchestrates containerized applications for automated deployment.",
    },
    {
        id: 2,
        image: "/assets/common/Devops/AWS.webp",
        title: "AWS",
        discription:
            "Extensive cloud platform providing diverse computing services.",
    },
    {
        id: 3,
        image: "/assets/common/Devops/Terraform.webp",
        title: "Terraform",
        discription:
            "Manages cloud infrastructure via code for resource provisioning.",
    },
    {
        id: 4,
        image: "/assets/common/Devops/bitbucket.webp",
        title: "Bit Bucket",
        discription:
            "Git repository management for seamless collaboration in development.",
    },
];

export const DevopsDataTech = [
    {
        id: 1,
        image: "/assets/common/Devops/GoogleCloud.webp",
        title: "Google Cloud",
    },
    { id: 2, image: "/assets/common/Devops/Bamboo.webp", title: "Bamboo" },
    {
        id: 3,
        image: "/assets/common/Devops/Prometheus.webp",
        title: "Prometheus",
    },
    { id: 4, image: "/assets/common/Devops/Azure.webp", title: "Azure" },
    {
        id: 5,
        image: "/assets/common/Devops/GCP.webp",
        title: "GCP",
    },
    {
        id: 6,
        image: "/assets/common/Devops/TeamCity.webp",
        title: "Team City",
    },
    {
        id: 7,
        image: "/assets/common/Devops/Nagios.webp",
        title: "Nagios",
    },
    {
        id: 8,
        image: "/assets/common/Devops/YandexCloud.webp",
        title: "Yandex Cloud",
    },
    {
        id: 9,
        image: "/assets/common/Devops/Cloudwatch.webp",
        title: "Cloudwatch",
    },
    { id: 10, image: "/assets/common/Devops/Sentry2.webp", title: "Sentry2" },
    {
        id: 11,
        image: "/assets/common/Devops/CloudSDK.webp",
        title: "Cloud SDK",
    },
    {
        id: 12,
        image: "/assets/common/Devops/AmazonAWS.webp",
        title: "Amazon AWS",
    },
    {
        id: 13,
        image: "/assets/common/Devops/Ansible.webp",
        title: "Ansible",
    },
    {
        id: 14,
        image: "/assets/common/Devops/DigitalOcean.webp",
        title: "Digital Ocean",
    },
    {
        id: 15,
        image: "/assets/common/Devops/Circle.webp",
        title: "Circle",
    },
    {
        id: 16,
        image: "/assets/common/Devops/CloudFormation.webp",
        title: "Cloud Formation",
    },
    { id: 17, image: "/assets/common/Devops/GitLab.webp", title: "Git Lab" },
    { id: 18, image: "/assets/common/Devops/Helmsh.webp", title: "Helmsh" },
    { id: 19, image: "/assets/common/Devops/Jenkins.webp", title: "Jenkins" },
    {
        id: 20,
        image: "/assets/common/Devops/Droneio.webp",
        title: "Drone.io",
    },
    {
        id: 21,
        image: "/assets/common/Devops/LiquiBase.webp",
        title: "Liqui Base",
    },
    {
        id: 22,
        image: "/assets/common/Devops/IBMCloud.webp",
        title: "IBM Cloud",
    },
    {
        id: 23,
        image: "/assets/common/Devops/Istioio.webp",
        title: "Istioio",
    },
    { id: 24, image: "/assets/common/Devops/Grafana.webp", title: "Grafana" },
    {
        id: 25,
        image: "/assets/common/Devops/ArgoCD.webp",
        title: "Argo CD",
    },
    {
        id: 26,
        image: "/assets/common/Devops/Serverless.webp",
        title: "Serverless",
    },
    {
        id: 27,
        image: "/assets/common/Devops/Travis.webp",
        title: "Travis",
    },
    {
        id: 28,
        image: "/assets/common/Devops/GitHubActions.webp",
        title: "GitHub Actions",
    },
];

export const ManagementData = [
    {
        id: 1,
        image: "/assets/common/Management/Jira.webp",
        title: "Jira",
        discription:
            "Project management tool for agile teams, facilitating software development workflows.",
    },
    {
        id: 2,
        image: "/assets/common/Management/Slack1.webp",
        title: "Slack",
        discription:
            "Messaging app for teams, enabling communication and collaboration.",
    },
    {
        id: 3,
        image: "/assets/common/Management/Podio1.webp",
        title: "Podio",
        discription:
            "Customizable work management solution for organizing team tasks and workflows.",
    },
    {
        id: 4,
        image: "/assets/common/Management/NTask.webp",
        title: "N Task",
        discription:
            "Task management tool for organizing and tracking tasks efficiently.",
    },
];

export const ManagementTech = [
    {
        id: 1,
        image: "/assets/common/Management/Backlog.webp",
        title: "Backlog",
    },
    {
        id: 2,
        image: "/assets/common/Management/KissflowProject.webp",
        title: "Kissflow Project",
    },
    { id: 3, image: "/assets/common/Management/Loom.webp", title: "Loom" },
    { id: 4, image: "/assets/common/Management/Quire.webp", title: "Quire" },
    {
        id: 5,
        image: "/assets/common/Management/Clickup.webp",
        title: "Clickup",
    },
    {
        id: 6,
        image: "/assets/common/Management/Zenhub.webp",
        title: "Zenhub",
    },
    {
        id: 7,
        image: "/assets/common/Management/Airtable.webp",
        title: "Airtable",
    },
    {
        id: 8,
        image: "/assets/common/Management/Basecamp.webp",
        title: "Basecamp",
    },
    {
        id: 9,
        image: "/assets/common/Management/Confluence.webp",
        title: "Confluence",
    },
    {
        id: 10,
        image: "/assets/common/Management/Jarosław.webp",
        title: "Jarosław",
    },
    {
        id: 11,
        image: "/assets/common/Management/Wrike.webp",
        title: "Wrike",
    },
    {
        id: 12,
        image: "/assets/common/Management/Asana.webp",
        title: "Asana",
    },
    {
        id: 13,
        image: "/assets/common/Management/ProjectManager.webp",
        title: "Project Manager",
    },
    {
        id: 14,
        image: "/assets/common/Management/Accenture.webp",
        title: "Accenture",
    },
    {
        id: 15,
        image: "/assets/common/Management/Nifty.webp",
        title: "Nifty",
    },
    { id: 16, image: "/assets/common/Management/Trello.webp", title: "Trello" },
    {
        id: 17,
        image: "/assets/common/Management/Govisually.webp",
        title: "Govisually",
    },
    {
        id: 18,
        image: "/assets/common/Management/Chanty.webp",
        title: "Chanty",
    },
    { id: 19, image: "/assets/common/Management/GMeet.webp", title: "GMeet" },
    {
        id: 20,
        image: "/assets/common/Management/TeamGantt.webp",
        title: "TeamGantt",
    },
    {
        id: 21,
        image: "/assets/common/Management/Redbooth.webp",
        title: "Redbooth",
    },
    {
        id: 22,
        image: "/assets/common/Management/GanttPro.webp",
        title: "Gantt Pro",
    },
    {
        id: 23,
        image: "/assets/common/Management/Mavenlink.webp",
        title: "Mavenlink",
    },
    {
        id: 24,
        image: "/assets/common/Management/Google_Docs.webp",
        title: "Google Docs",
    },
    {
        id: 25,
        image: "/assets/common/Management/GoogleTasks.webp",
        title: "Google Tasks",
    },
    {
        id: 26,
        image: "/assets/common/Management/Zenkit.webp",
        title: "Zenkit",
    },
    {
        id: 27,
        image: "/assets/common/Management/Capgemini.webp",
        title: "Capgemini",
    },
];

export const UIUXData = [
    {
        id: 1,
        image: "/assets/common/UiUx/Figma.webp",
        title: "Figma",
        discription:
            "Collaborative interface design tool enabling real-time editing and prototyping.",
    },
    {
        id: 2,
        image: "/assets/common/UiUx/AdobePhotoshop.webp",
        title: "Adobe Photoshop",
        discription:
            "Industry-standard software for image editing and digital art creation.",
    },
    {
        id: 3,
        image: "/assets/common/UiUx/AdobeAfterEffects.webp",
        title: "Adobe After Effects",
        discription:
            "Motion graphics and visual effects software for cinematic visual content.",
    },
    {
        id: 4,
        image: "/assets/common/UiUx/AdobeIllustrator.webp",
        title: "Adobe Illustrator",
        discription:
            "Vector graphics editor for creating logos, icons, illustrations, and more.",
    },
];

export const UIUXDataTech = [
    { id: 1, image: "/assets/common/UiUx/Principle.webp", title: "Principle" },
    {
        id: 2,
        image: "/assets/common/UiUx/Axure.webp",
        title: "Axure",
    },
    { id: 3, image: "/assets/common/UiUx/Sketch.webp", title: "Sketch" },
    {
        id: 4,
        image: "/assets/common/UiUx/AdobeCreativeCloud.webp",
        title: "Adobe Creative Cloud",
    },
    { id: 5, image: "/assets/common/UiUx/Zeplin.webp", title: "Zeplin" },
    {
        id: 6,
        image: "/assets/common/UiUx/FlowMapp.webp",
        title: "Flow Mapp",
    },
    { id: 7, image: "/assets/common/UiUx/Adobe_XD.webp", title: "Adobe XD" },
    { id: 8, image: "/assets/common/UiUx/Mural.webp", title: "Mural" },
    { id: 9, image: "/assets/common/UiUx/ProtoPie.webp", title: "Proto Pie" },
    { id: 10, image: "/assets/common/UiUx/Animate.webp", title: "Animate" },
    {
        id: 11,
        image: "/assets/common/UiUx/Lottie.webp",
        title: "Lottie",
    },
    {
        id: 12,
        image: "/assets/common/UiUx/Premiere Pro.webp",
        title: "Premiere Pro",
    },
    { id: 13, image: "/assets/common/UiUx/Framer.webp", title: "Framer" },
    { id: 14, image: "/assets/common/UiUx/Maze.webp", title: "Maze" },
    {
        id: 15,
        image: "/assets/common/UiUx/Overflow.webp",
        title: "Overflow",
    },
    {
        id: 16,
        image: "/assets/common/UiUx/OptimalWorkshop.webp",
        title: "Optimal Workshop",
    },
    {
        id: 17,
        image: "/assets/common/UiUx/Adobe-Suite.webp",
        title: "Adobe Suite",
    },
    { id: 18, image: "/assets/common/UiUx/Milanote.webp", title: "Milanote" },
    {
        id: 19,
        image: "/assets/common/UiUx/Visualsitemaps.webp",
        title: "Visualsite Maps",
    },
    {
        id: 20,
        image: "/assets/common/UiUx/UXpin.webp",
        title: "UXpin",
    },
    {
        id: 21,
        image: "/assets/common/UiUx/OrigamiStudio.webp",
        title: "Origami Studio",
    },
    { id: 22, image: "/assets/common/UiUx/Abstract.webp", title: "Abstract" },
    { id: 23, image: "/assets/common/UiUx/LookBack.webp", title: "LookBack" },
    { id: 24, image: "/assets/common/UiUx/Miro.webp", title: "Miro" },
    {
        id: 25,
        image: "/assets/common/UiUx/Proto.io.webp",
        title: "Proto.io",
    },
    {
        id: 26,
        image: "/assets/common/UiUx/Invisible.webp",
        title: "Invisible",
    },
    {
        id: 27,
        image: "/assets/common/UiUx/Notion.webp",
        title: "Notion",
    },
    {
        id: 28,
        image: "/assets/common/UiUx/Webflow.webp",
        title: "Webflow",
    },
    {
        id: 29,
        image: "/assets/common/UiUx/MarvelApp.webp",
        title: "Marvel App",
    },
];

export const MobileData = [
    {
        id: 1,
        image: "/assets/common/Mobile/ReactNative.webp",
        title: "React Native",
        discription:
            "Cross-platform framework for building mobile apps efficiently.",
    },
    {
        id: 2,
        image: "/assets/common/Mobile/Flutter.webp",
        title: "Flutter",
        discription:
            "UI toolkit by Google for creating natively compiled applications.",
    },
    {
        id: 3,
        image: "/assets/common/Mobile/Swift.webp",
        title: "Swift",
        discription:
            "Powerful and intuitive programming language for iOS, macOS, watchOS, and tvOS apps.",
    },
    {
        id: 4,
        image: "/assets/common/Mobile/Kotlin.webp",
        title: "Kotlin",
        discription:
            "Modern language for Android development by JetBrains and Google.",
    },
];

export const MobileTech = [
    { id: 1, image: "/assets/common/Mobile/Android.webp", title: "Android" },
    { id: 2, image: "/assets/common/Mobile/ios.webp", title: "ios" },
    { id: 3, image: "/assets/common/Mobile/Metal.webp", title: "Metal" },
    { id: 4, image: "/assets/common/Mobile/Java.webp", title: "Java" },
    {
        id: 5,
        image: "/assets/common/Mobile/ionic.webp",
        title: "ionic",
    },
    {
        id: 6,
        image: "/assets/common/Mobile/Fastlane.webp",
        title: "Fastlane",
    },
    { id: 7, image: "/assets/common/Mobile/OnsenUI.webp", title: "Onsen UI" },
    { id: 8, image: "/assets/common/Mobile/Realm.webp", title: "Realm" },
    { id: 9, image: "/assets/common/Mobile/Jetpack.webp", title: "Jetpack" },
    { id: 10, image: "/assets/common/Mobile/Buddy.webp", title: "Buddy" },
    {
        id: 11,
        image: "/assets/common/Mobile/Cocoapods.webp",
        title: "Cocoapods",
    },
    {
        id: 12,
        image: "/assets/common/Mobile/Carthage.webp",
        title: "Carthage",
    },
    {
        id: 13,
        image: "/assets/common/Mobile/AppyPie.webp",
        title: "Appy Pie",
    },
    { id: 14, image: "/assets/common/Mobile/Firebase.webp", title: "Firebase" },
    {
        id: 15,
        image: "/assets/common/Mobile/Quickbase.webp",
        title: "Quickbase",
    },
    {
        id: 16,
        image: "/assets/common/Mobile/Genexusbuilder.webp",
        title: "Genexus builder",
    },
    {
        id: 17,
        image: "/assets/common/Mobile/Agdk.webp",
        title: "Agdk",
    },
    { id: 18, image: "/assets/common/Mobile/Xamarin.webp", title: "Xamarin" },
    { id: 19, image: "/assets/common/Mobile/Dart.webp", title: "Dart" },
    {
        id: 20,
        image: "/assets/common/Mobile/TensorFlow.webp",
        title: "TensorFlow",
    },
    {
        id: 21,
        image: "/assets/common/Mobile/AppSheet.webp",
        title: "App Sheet",
    },
    {
        id: 22,
        image: "/assets/common/Mobile/Pusher.webp",
        title: "Pusher",
    },
    {
        id: 23,
        image: "/assets/common/Mobile/Jamf.webp",
        title: "Jamf",
    },
    { id: 24, image: "/assets/common/Mobile/Gradle.webp", title: "Gradle" },
    { id: 25, image: "/assets/common/Mobile/Maven.webp", title: "Maven" },
    {
        id: 26,
        image: "/assets/common/Mobile/Objective-C.webp",
        title: "Objective C",
    },
    {
        id: 27,
        image: "/assets/common/Mobile/Kobiton.webp",
        title: "Kobiton",
    },
    { id: 28, image: "/assets/common/Mobile/Obj_c.webp", title: "Obj c" },
    {
        id: 29,
        image: "/assets/common/Mobile/RXJava.webp",
        title: "RX Java",
    },
];
